module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-event",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "ds-event-header ds-event-area"
  }, [(_vm.hasCancel) ? _c('div', {
    staticClass: "ds-event-cancel"
  }, [_vm._t("scheduleCancel", [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ds-button",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.cancel)
    }
  })], 1)], null, {
    cancel: _vm.cancel,
    labels: _vm.labels
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ds-event-actions"
  }, [_vm._t("scheduleSave", [(!_vm.isReadOnly) ? _c('v-btn', {
    staticClass: "ds-button-tall ml-3 mt-0 mb-2",
    attrs: {
      "depressed": "",
      "color": "primary",
      "disabled": !_vm.canSave
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.save)
    }
  })]) : _vm._e()], null, {
    hasSave: _vm.hasSave,
    save: _vm.save,
    labels: _vm.labels,
    readOnly: _vm.readOnly
  }), _vm._v(" "), _vm._t("scheduleActions", [(_vm.calendarEvent && !_vm.isReadOnly) ? _c('ds-schedule-actions', _vm._g(_vm._b({
    attrs: {
      "schedule": _vm.schedule,
      "calendar-event": _vm.calendarEvent,
      "calendar": _vm.calendar
    },
    on: {
      "finish": _vm.actioned
    }
  }, 'ds-schedule-actions', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners), [_c('v-btn', {
    staticClass: "ds-button-tall ml-1 mt-0 mb-2",
    attrs: {
      "depressed": ""
    }
  }, [_vm._v("\n             " + _vm._s(_vm.labels.moreActions) + "\n          ")])], 1) : _vm._e()], null, {
    calendarEvent: _vm.calendarEvent,
    schedule: _vm.schedule,
    calendar: _vm.calendar,
    actioned: _vm.actioned,
    readOnly: _vm.readOnly
  })], 2), _vm._v(" "), _vm._t("scheduleTitle", [_c('v-text-field', {
    staticClass: "ds-event-title",
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "label": _vm.labels.title,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.details.title),
      callback: function($$v) {
        _vm.$set(_vm.details, "title", $$v)
      },
      expression: "details.title"
    }
  })], null, {
    schedule: _vm.schedule,
    schedule: _vm.schedule,
    calendarEvent: _vm.calendarEvent,
    details: _vm.details
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "ds-event-body ds-event-area"
  }, [_vm._t("schedule", [_c('ds-schedule', {
    attrs: {
      "schedule": _vm.schedule,
      "day": _vm.day,
      "read-only": _vm.readOnly
    }
  })], null, _vm.slotData)], 2), _vm._v(" "), (_vm.hasTabs) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    staticClass: "text--primary",
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [(_vm.hasDetails) ? _c('v-tab', {
    attrs: {
      "href": "#details"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labels.tabs.details) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showForecast) ? _c('v-tab', {
    attrs: {
      "href": "#forecast"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labels.tabs.forecast) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showExclusions) ? _c('v-tab', {
    attrs: {
      "href": "#exclusions"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labels.tabs.removed) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showInclusions) ? _c('v-tab', {
    attrs: {
      "href": "#inclusions"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labels.tabs.added) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showCancels) ? _c('v-tab', {
    attrs: {
      "href": "#cancelled"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labels.tabs.cancelled) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._t("eventTabsExtra", null, null, _vm.slotData), _vm._v(" "), (_vm.hasDetails) ? _c('v-tab-item', {
    attrs: {
      "value": "details"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("eventDetailsLocation", [(_vm.$dayspan.supports.location) ? _c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "prepend-icon": "location_on",
      "label": _vm.labels.location,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.details.location),
      callback: function($$v) {
        _vm.$set(_vm.details, "location", $$v)
      },
      expression: "details.location"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsDescription", [(_vm.$dayspan.supports.description) ? _c('v-textarea', {
    attrs: {
      "hide-details": "",
      "single-line": "",
      "solo": "",
      "flat": "",
      "prepend-icon": "subject",
      "label": _vm.labels.description,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.details.description),
      callback: function($$v) {
        _vm.$set(_vm.details, "description", $$v)
      },
      expression: "details.description"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsCalendar", [(_vm.$dayspan.supports.calendar) ? _c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "readonly": "",
      "prepend-icon": "event",
      "label": _vm.labels.calendar,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.details.calendar),
      callback: function($$v) {
        _vm.$set(_vm.details, "calendar", $$v)
      },
      expression: "details.calendar"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsColor", [(_vm.$dayspan.supports.color) ? _c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "prepend-icon": "invert_colors",
      "items": _vm.$dayspan.colors,
      "color": _vm.details.color,
      "disabled": _vm.isReadOnly
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-tile-content', [_c('div', {
          staticClass: "ds-color-option",
          style: ({
            backgroundColor: item.value
          }),
          domProps: {
            "textContent": _vm._s(item.text)
          }
        })])]
      }
    }]),
    model: {
      value: (_vm.details.color),
      callback: function($$v) {
        _vm.$set(_vm.details, "color", $$v)
      },
      expression: "details.color"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsIcon", [(_vm.$dayspan.supports.icon) ? _c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "prepend-icon": _vm.details.icon || 'help',
      "items": _vm.$dayspan.icons,
      "disabled": _vm.isReadOnly
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(item.value))])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                      " + _vm._s(item.text) + "\n                    ")])]
      }
    }]),
    model: {
      value: (_vm.details.icon),
      callback: function($$v) {
        _vm.$set(_vm.details, "icon", $$v)
      },
      expression: "details.icon"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsBusy", [(_vm.$dayspan.supports.busy) ? _c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "prepend-icon": "work",
      "items": _vm.busyOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.details.busy),
      callback: function($$v) {
        _vm.$set(_vm.details, "busy", $$v)
      },
      expression: "details.busy"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsExtra", null, null, _vm.slotData)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showForecast) ? _c('v-tab-item', {
    attrs: {
      "value": "forecast",
      "lazy": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("eventForecast", [_c('ds-schedule-forecast', {
    attrs: {
      "schedule": _vm.schedule,
      "day": _vm.day,
      "read-only": _vm.readOnly
    }
  })], null, _vm.slotData)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showExclusions) ? _c('v-tab-item', {
    attrs: {
      "value": "exclusions",
      "lazy": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("eventExclusions", [_c('ds-schedule-modifier', {
    attrs: {
      "description": _vm.labels.exclusions,
      "modifier": _vm.schedule.exclude,
      "read-only": _vm.readOnly
    }
  })], null, _vm.slotData)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showInclusions) ? _c('v-tab-item', {
    attrs: {
      "value": "inclusions",
      "lazy": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("eventInclusions", [_c('ds-schedule-modifier', {
    attrs: {
      "description": _vm.labels.inclusions,
      "modifier": _vm.schedule.include,
      "read-only": _vm.readOnly
    }
  })], null, _vm.slotData)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCancels) ? _c('v-tab-item', {
    attrs: {
      "value": "cancelled",
      "lazy": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("eventCancels", [_c('ds-schedule-modifier', {
    attrs: {
      "description": _vm.labels.cancelled,
      "modifier": _vm.schedule.cancel,
      "read-only": _vm.readOnly
    }
  })], null, _vm.slotData)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("eventTabItemsExtra", null, null, _vm.slotData)], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b1da002","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Event.vue
// module id = 155
// module chunks = 0